// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"816c7434","707":"3424a9dc","729":"42aa2166"}[chunkId] + ".js";
};